import React, { useState, useEffect } from "react";
import { Avatar } from "@mui/material";
import ModalSkeleton from "./ModalSkeleton";
import IMG from "../assets/images/Companies_bg.png";
import "../assets/styles/appliedCraftmanModal.css";
import { apiHeader, imageUrl, pdfUrl, URL } from "../Config/apiUrl";
import { useHistory } from "react-router-dom";
import { Col, Row, Form, Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Get, Post } from "../Axios/AxiosFunctions";
import { toast } from "react-toastify";

function ReportJobModal({ open, setOpen, data, isLoading, onSubmit }) {
  const [selectedReport, setSelectedReport] = useState(null);

  return (
    <ModalSkeleton title="Report Job" open={open} setOpen={setOpen}>
      <section>
        <div class="list-group">
          {data?.map((e) => (
            <a
              key={e?._id}
            //   href="#"
              class={`list-group-item list-group-item-action c-p ${
                e?._id == selectedReport && "active"
              }`}
              onClick={() => setSelectedReport(e?._id)}
            >
              {e?.description}
            </a>
          ))}
        </div>
      </section>

      <Modal.Footer>
        <Button
          disabled={isLoading}
          variant="primary"
          onClick={onSubmit.bind(this, selectedReport)}
        >
          {isLoading ? "Please wait..." : "Report Job"}
        </Button>
      </Modal.Footer>
    </ModalSkeleton>
  );
}

export default ReportJobModal;
